import type { GridColDef, GridRenderCellParams } from "@leap4/frontend";
import { BaseGenericItemsStore, GenericItemsForm, GenericItemsUtils, IGetAllParams, MuiIcons } from "@leap4/frontend";
import { connect, ConnectedProps } from "react-redux";
import { Link } from "react-router-dom";
import { PublisherLoginsBaseUrl } from "../../../config/generals";
import { RootState } from "../../../interfaces/root-state.interface";
import { urlService } from "../../routing/urlsService";

const { Groups: GroupsIcon } = MuiIcons;

const fields = {
    advertiserName: 1,
    publisherName: 1,
}

const getParams: IGetAllParams = {
    fields
}
let columns: GridColDef[];
let store: BaseGenericItemsStore<{ _id: string, isActive: boolean }>

function setStoreAndColumns() {
    const storeAndColumns = GenericItemsUtils.GenerateDefaultStoreAndColumns({
        baseUrl: `${PublisherLoginsBaseUrl}`
    }, fields, {
        created: {},
        isActive: {},
        updated: {},
        name: { editLinkFunc: (id: string) => urlService.editPublisherLogins(id) }
    })
    store = storeAndColumns.store;
    columns = storeAndColumns.columns;
    const advertiserCol = columns.find(x => (x.field === "advertiserName"));
    const publisherCol = columns.find(x => (x.field === "publisherName"));
    publisherCol.headerName = "Publisher"
    advertiserCol.headerName = "Advertiser"
    advertiserCol.renderCell = (params: GridRenderCellParams) => {
        const advertiserOrgId = params.id.toString().split("_")[0];
        return <Link to={urlService.editOrganization(advertiserOrgId)}><strong>{params.value}</strong></Link>
    };
    publisherCol.renderCell = (params: GridRenderCellParams) => {
        const publisherOrgId = params.id.toString().split("_")[1];
        return <Link to={urlService.editOrganization(publisherOrgId)}><strong>{params.value}</strong></Link>
    };
}

const mapStateToProps = (state: RootState) => ({
    selectedOrganization: state.auth.selectedOrganizationId
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

const PublisherLoginsDashboardModule = (props: PropsFromRedux) => {
    setStoreAndColumns();

    return (
        <GenericItemsForm
            organization={props.selectedOrganization}
            columns={columns}
            store={store}
            breadcrumbs={{
                link: urlService.publisherLogins(),
                text: "Publisher logins Dashboard",
                icon: <GroupsIcon />
            }}
            tableProps={{ pageSize: 100, style: { minHeight: "75vh" } }}
            getAllParams={getParams}

        />
    );
};

export default connector(PublisherLoginsDashboardModule)
